import { render, staticRenderFns } from "./PoisList.vue?vue&type=template&id=c3ab265a&"
import script from "./PoisList.vue?vue&type=script&lang=js&"
export * from "./PoisList.vue?vue&type=script&lang=js&"
import style0 from "./PoisList.vue?vue&type=style&index=0&id=c3ab265a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports